<template>
  <div class="edit-street-page">
    <div class="head-wrap flex-rowl">
      <div class="icon">
        <img src="../../../assets/images/business-title-icon.png" alt="" />
      </div>
      <div class="head-content">
        <h1>新增陪护服务合作机构</h1>
        <p>加盟及服务合作机构</p>
      </div>
    </div>

    <!-- 表单 -->
    <div class="from-wrap">
      <div class="from-item mb_85">
        <div class="label">
          <span class="requird"></span>陪护服务合作机构名称：
        </div>
        <div class="input-box">
          <input
            type="text"
            placeholder="请输入陪护服务合作机构名称，30个字符内"
            maxlength="30"
            v-model="params.insname"
          />
        </div>
      </div>
      <div class="from-item mb_85">
        <div class="label"><span class="requird"></span>联系电话：</div>
        <div class="input-box">
          <input
            type="text"
            placeholder="请输入陪护服务合作机构联系电话"
            v-model="params.mobile"
          />
        </div>
      </div>
      <div class="from-item mb_85">
        <div class="label">
          <span class="requird"></span>客服电话：<span class="mark"
            >（注意，客服电话将显示给服务端用户可见）</span
          >
        </div>
        <div class="input-box">
          <input
            type="text"
            placeholder="请输入在服务端显示的客服电话"
            v-model="params.tel"
          />
        </div>
      </div>
      <div class="from-item form-item-radio mb_85">
        <div class="label"><span class="requird"></span>合作状态：</div>
        <div class="radio-box">
          <div
            class="radio-item flex-between"
            :class="{ active: params.inssate === '1' }"
            @click="handleRadio('1')"
          >
            合作中（启用）
          </div>
          <div
            class="radio-item flex-between"
            :class="{ active: params.inssate === '0' }"
            @click="handleRadio('0')"
          >
            暂停合作（停用）
          </div>
        </div>
      </div>

      <div class="from-item">
        <div class="label">
          陪护服务合作机构LOGO：<span class="mark"
            >（注意，此项为非必填项）</span
          >
        </div>
        <div class="upload-wrap flex-rowc">
          <div class="upload-box flex-rowc">
            <input
              ref="imageInput"
              type="file"
              accept="image/*"
              @change="handleFileChange"
            />
            <van-image
              width="100%"
              height="100%"
              fit="cover"
              :src="params.logo"
              v-if="params.logo"
            />
            <div class="no-img" v-else></div>
            
          </div>
        </div>
      </div>
    </div>

    <!-- 底部 -->
    <div class="fixed-btm flex-rowc">
      <div class="return flex-rowc" @click="handleBack">返回</div>
      <div
        class="add-btn flex-rowc"
        :class="{ disanled: isSubmitting }"
        @click="handleSubmit"
      >
        确认·保存
      </div>
    </div>
  </div>
</template>

<script>
import {
  addCooperationOrg,
  editCooperationOrg,
  getCooperationOrgDetail,
} from "../../../api/api";
import { uploadImage } from "../../../api/public";
export default {
  name: "EditServiceCooperation",
  data() {
    return {
      // 参数
      params: {
        id: "",
        insname: "",
        logo: "",
        mobile: "",
        tel: "",
        inssate: "",
      },

      isSubmitting: false, // 提交中标记
    };
  },
  created() {
    if (this.$route.query.id) {
      this.params.id = this.$route.query.id;
      // 等 getAreaList 完成后，调用 getCooperationOrgDetail 方法
      this.getCooperationOrgDetail();
    }
  },
  methods: {
    // 获取街道详情
    async getCooperationOrgDetail() {
      const res = await getCooperationOrgDetail(this.params.id);
      try {
        this.params.insname = res.insname;
        this.params.logo = res.logo;
        this.params.mobile = res.mobile;
        this.params.tel = res.tel;
        this.params.inssate = res.inssate;
      } catch (error) {
        console.error("获取街道详情失败:", error);
        this.$toast.fail("获取街道详情失败，请稍后重试");
      }
    },

    // 触发单选框
    handleRadio(item) {
      this.params.inssate = item;
    },

    // 处理文件选择事件
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.handleChooseImg(file);
        // 清空 input 的值，以便下次选择相同文件时能触发 change 事件
        this.$refs.imageInput.value = "";
      }
    },
    // 上传图片
    async handleChooseImg(data) {
      const toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      const formData = new FormData();
      formData.append("imgfile", data);
      try {
        const res = await uploadImage(formData);
        if (res.result) {
          this.params.logo = res.url
        } else {
          this.$toast.fail(res.message || "上传失败");
        }
      } catch (error) {
        console.error("图片上传请求出错:", error);
        this.$toast.fail("上传失败，请稍后重试");
      } finally {
        toast.clear();
      }
    },

    // 返回上一页
    handleBack() {
      this.$router.back();
    },

    // 提交
    async handleSubmit() {
      let { insname, mobile, tel, inssate } = this.params;
      if (!insname) {
        this.$toast("请输入陪护服务合作机构名称");
        return;
      }
      if (!mobile) {
        this.$toast("请输入陪护服务合作机构联系电话");
        return;
      }
      if (!tel) {
        this.$toast("请输入在服务端显示的客服电话");
        return;
      }
      if (!inssate) {
        this.$toast("请选择合作状态");
        return;
      }

      // 如果正在提交，直接返回
      if (this.isSubmitting) return;

      // 设置提交中标记
      this.isSubmitting = true;
      // 显示加载中提示
      this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
        duration: 0,
      });
      try {
        let res;
        if (this.params.id) {
          // params.id 存在，调用 editCooperationOrg 接口
          res = await editCooperationOrg(this.params);
        } else {
          // params.id 不存在，调用 addCooperationOrg 接口
          res = await addCooperationOrg(this.params);
        }

        if (res.result == "true") {
          await new Promise((resolve) => setTimeout(resolve, 400));
          this.$toast.success("提交成功");

          await new Promise((resolve) => setTimeout(resolve, 800));
          // 提交成功后返回上一页
          this.$toast.clear();
          this.$router.back();
          // this.isSubmitting = false;
        } else {
          this.$toast.fail(res.message || "提交失败，请稍后重试");
          this.isSubmitting = false;
        }
      } catch (error) {
        console.error("提交出错:", error);
        this.$toast.fail("提交出错，请稍后重试");
        this.isSubmitting = false;
      } finally {
        // // 无论成功或失败，都关闭加载提示并重置提交状态
        // this.$toast.clear();
        // this.isSubmitting = false;
      }
    },
  },
};
</script>

<style scoped lang="less">
.edit-street-page {
  padding-bottom: 380px;
  box-sizing: border-box;
  .head-wrap {
    width: 700px;
    margin: auto;
    padding: 70px 0 98px 58px;
    box-sizing: border-box;
    font-size: 20px;
    color: #333333;
    .icon {
      width: 33px;
      height: 40px;
      margin-right: 24px;
    }
    h1 {
      font-size: 30px;
      margin-bottom: 7px;
    }
  }
  .from-wrap {
    width: 600px;
    margin: auto;
    .from-item {
      .label {
        position: relative;
        font-size: 26px;
        color: #333333;
        padding-left: 12px;
        box-sizing: border-box;
        margin-bottom: 23px;
        .requird {
          width: 15px;
          height: 15px;
          background: url("../../../assets/images/required-icon.png") no-repeat
            center;
          background-size: cover;
          display: inline-block;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: -12px;
        }
        .mark {
          font-size: 22px;
          color: #ff0000;
        }
      }
      &.form-item-radio {
        .label {
          margin-bottom: 60px;
        }
      }
      .input-box,
      .select-box {
        border-bottom: 1px solid #c3c3c3;
        font-size: 24px;
        height: 52px;
        padding: 0 13px;
        box-sizing: border-box;
        input {
          height: 100%;
          width: 100%;
          background: none;
        }
      }
      .select-box {
        position: relative;
        border-bottom: 1px dashed #c3c3c3;
        padding-right: 20px;
        color: #aaaaaa;
        &.has-value {
          color: #333333;
        }
        input {
          text-align: center;
        }
        &::after {
          display: inline-block;
          content: "";
          background: url("../../../assets/images/select-icon.png") no-repeat
            center;
          background-size: cover;
          width: 26px;
          height: 30px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 10px;
        }
      }
      .radio-box {
        font-size: 24px;
        color: #464646;
        .radio-item {
          width: 495px;
          height: 60px;
          background: #dfe0e7;
          border-radius: 30px;
          margin-bottom: 30px;
          border: 2px solid #dfe0e7;
          padding: 0 22px 0 44px;
          box-sizing: border-box;
          cursor: pointer;
          &:last-child {
            margin-bottom: 0;
          }
          &.active {
            border: 2px solid #0031c9;
            background: #deffff;
            &::after {
              display: inline-block;
              content: "";
              display: inline-block;
              width: 33px;
              height: 23px;
              background: url("../../../assets/images/radio-icon1.png")
                no-repeat center;
              background-size: cover;
            }
          }
        }
      }
      .upload-wrap {
        width: 600px;
        height: 688px;
        background: rgba(255, 255, 255, 0);
        border: 2px solid #dedce8;
        margin-top: 46px;
        .upload-box {
          width: 500px;
          height: 588px;
          background: rgba(238, 238, 238, .5);
          position: relative;
          cursor: pointer;
          .no-img {
            width: 163px;
            height: 163px;
            background: url("../../../assets/images/upload-icon.png") no-repeat
              center;
            background-size: cover;
          }
          input {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            opacity: 0;
            z-index: 9;
            cursor: pointer;
          }
        }
      }
    }
    .from-item-address {
      color: #333333;
      .tit {
        font-size: 26px;

        font-weight: bold;
        margin-bottom: 59px;
        padding-left: 19px;
        box-sizing: border-box;
        position: relative;
        &::before {
          display: inline-block;
          content: "";
          background: url("../../../assets/images/address-form-icon.png")
            no-repeat center;
          background-size: cover;
          width: 28px;
          height: 35px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: -20px;
        }
      }
      .txt {
        font-size: 26px;
        padding-left: 13px;
        box-sizing: border-box;
        p {
          &:last-child {
            margin-top: 30px;
          }
        }
      }
    }
    .mb_85 {
      margin-bottom: 85px;
    }
    .mb_75 {
      margin-bottom: 75px;
    }
    .mb_100 {
      margin-bottom: 100px;
    }
    .mb_60 {
      margin-bottom: 60px;
    }
  }
  .fixed-btm {
    position: fixed;
    bottom: 0;
    height: 150px;
    background: #fff;
    z-index: 10;
    align-items: flex-start;
    width: 100%;
    max-width: 750px;
    margin: auto;
    cursor: pointer;
    .return {
      font-size: 24px;
      color: #000000;
      height: 100%;
      width: 150px;
      align-items: flex-start;
      padding-top: 50px;
      box-sizing: border-box;
      margin-right: 30px;
      &::before {
        display: inline-block;
        content: "";
        background: url("../../../assets/images/return-icon.png") no-repeat
          center;
        background-size: cover;
        width: 15px;
        height: 25px;
        margin-right: 8px;
      }
    }
    .add-btn {
      width: 210px;
      height: 50px;
      background: #0031c9;
      border-radius: 25px;
      font-size: 24px;
      color: #fff;
      margin-top: 38px;
      &.disanled {
        background: #d9d9d9;
      }
    }
  }
}
</style>